import axios from "axios";
import toast from "react-hot-toast";

const { REACT_APP_BASE_URL } = process.env;

// Extracted from CanvassMap.js's fatchStats so the dual-endpoint HTTP logic
// can be tested without mounting the full map component.
// Replaces the old single POST /contactStatistics call (which downloads
// every matching contact) with two lightweight, parallel count-based
// endpoints: /contactAttempts (Door Knock record count only) and
// /contactRates (count-based HubSpot queries for percentages/rating).
export async function fetchContactStats({
  token,
  setTotalAttempts,
  setTotalConversion,
  setTotalRating,
  setContactedVoters,
  setDailyCount,
}) {
  const currentDate = new Date();
  const today = currentDate?.toLocaleDateString("en-GB");
  const ownerID = localStorage.getItem("ownerId");
  if (!ownerID) return;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const payload = { owner_id: ownerID, date: today };

  await Promise.all([
    axios.post(`${REACT_APP_BASE_URL}/contactAttempts`, payload, { headers }),
    axios.post(`${REACT_APP_BASE_URL}/contactRates`, payload, { headers }),
  ])
    .then(([attemptsRes, ratesRes]) => {
      setTotalAttempts(attemptsRes?.data?.overall?.tracking_attempts || 0);
      setTotalConversion(ratesRes?.data?.overall?.tracking_conversion_percent || 0);
      setTotalRating(ratesRes?.data?.overall?.tracking_rating || 0);
      setContactedVoters(ratesRes?.data?.overall?.tracking_contacted_voters_percent || 0);

      if (setDailyCount) {
        setDailyCount({
          totalAttempt: attemptsRes?.data?.daily?.tracking_attempts || 0,
          tracking_contacted_voters_percent: ratesRes?.data?.daily?.tracking_contacted_voters_percent || 0,
          tracking_conversion_percent: ratesRes?.data?.daily?.tracking_conversion_percent || 0,
          tracking_rating: ratesRes?.data?.daily?.tracking_rating || 0,
        });
      }
    })
    .catch((e) => {
      // navigator.onLine only reflects the network interface being up, not
      // that the internet actually works - it stays true when connected to
      // a router/WiFi with no real upstream connectivity. In that case
      // axios fails every request with a generic "Network Error" (no
      // response object), and showing that raw message as a toast on every
      // page load/refresh is just noise the user can't act on. Only surface
      // an actual server-returned error; log connectivity failures instead.
      if (e?.response) {
        toast.error(e?.response?.data?.message || "Something went wrong!");
      } else {
        console.error("Error fetching stats:", e);
      }
    });
}
